import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { ShoppingCartIcon } from 'lucide-react';
import { Notification } from './Notification';
interface ProductDetails {
  id: number;
  name: string;
  category: string;
  thc: string;
  strain: 'Indica' | 'Sativa' | 'Hybrid';
  image: string;
  potencyLevels: {
    thc: string;
    cbd: string;
    terpenes: string;
  };
  effects: string[];
  description: string;
  price: number;
}
const products: ProductDetails[] = [{
  id: 1,
  name: 'Chicago OG',
  category: 'Premium Flower',
  thc: '32%',
  strain: 'Indica',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wkoEddbgj1wuBJsqvECQwT/Screenshot_2025-04-12_at_12.03.31_PM.png',
  potencyLevels: {
    thc: '32%',
    cbd: '0.5%',
    terpenes: '4.2%'
  },
  effects: ['Relaxing', 'Sleep Aid', 'Pain Relief'],
  description: 'A powerful indica strain with deep relaxing effects.',
  price: 50.0
}, {
  id: 2,
  name: 'Cold Snap',
  category: 'Exotic Flower',
  thc: '29%',
  strain: 'Sativa',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3JBY5BMV1xekQZpxxhhu9w/Screenshot_2025-04-12_at_12.03.48_PM.png',
  potencyLevels: {
    thc: '29%',
    cbd: '0.3%',
    terpenes: '3.5%'
  },
  effects: ['Euphoria', 'Energy Boost', 'Focus'],
  description: 'A sativa strain with energizing effects.',
  price: 50.0
}, {
  id: 3,
  name: 'Frost Bite',
  category: 'Limited Edition',
  thc: '31%',
  strain: 'Hybrid',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hcPzKC9RXrYTcXfgMVRryh/Screenshot_2025-04-12_at_12.04.06_PM.png',
  potencyLevels: {
    thc: '31%',
    cbd: '0.4%',
    terpenes: '4.0%'
  },
  effects: ['Relaxing', 'Focus', 'Stress Relief'],
  description: 'A hybrid strain with balanced effects.',
  price: 50.0
}, {
  id: 4,
  name: 'Crystal Haze',
  category: 'Top Shelf',
  thc: '30%',
  strain: 'Indica',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dpWeESi4FW9jrHteSEoH2b/Screenshot_2025-04-12_at_12.04.17_PM.png',
  potencyLevels: {
    thc: '30%',
    cbd: '0.2%',
    terpenes: '3.8%'
  },
  effects: ['Relaxing', 'Sleep Aid', 'Stress Relief'],
  description: 'A powerful indica strain with deep relaxing effects.',
  price: 50.0
}];
interface ProductModalProps {
  product: ProductDetails;
  onClose: () => void;
}
const ProductModal: React.FC<ProductModalProps> = ({
  product,
  onClose
}) => {
  const [showNotification, setShowNotification] = useState(false);
  const {
    dispatch
  } = useCart();
  const handleAddToCart = () => {
    dispatch({
      type: 'ADD_ITEM',
      payload: {
        id: product.id,
        name: product.name,
        price: 50.0,
        quantity: 1,
        image: product.image,
        strain: product.strain,
        thc: product.thc
      }
    });
    setShowNotification(true);
    onClose();
  };
  return <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-183">
      <div className="bg-glass border border-red-600/20 rounded-xl max-w-2xl w-full p-6 relative" data-id="element-184">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white" data-id="element-185">
          <XIcon size={24} data-id="element-186" />
        </button>
        <div className="flex flex-col md:flex-row gap-6" data-id="element-187">
          <div className="md:w-1/2" data-id="element-188">
            <img src={product.image} alt={product.name} className="w-full rounded-lg" data-id="element-189" />
          </div>
          <div className="md:w-1/2" data-id="element-190">
            <h3 className="font-display italic text-2xl font-bold text-white mb-2" data-id="element-191">
              {product.name}
            </h3>
            <p className="text-red-500 font-bold mb-4" data-id="element-192">{product.strain}</p>
            <div className="space-y-4" data-id="element-193">
              <div data-id="element-194">
                <h4 className="text-gray-400 text-sm mb-2" data-id="element-195">Potency Levels</h4>
                <div className="grid grid-cols-3 gap-4" data-id="element-196">
                  <div className="bg-black/50 p-3 rounded-lg text-center" data-id="element-197">
                    <p className="text-xs text-gray-400" data-id="element-198">THC</p>
                    <p className="text-white font-bold" data-id="element-199">
                      {product.potencyLevels.thc}
                    </p>
                  </div>
                  <div className="bg-black/50 p-3 rounded-lg text-center" data-id="element-200">
                    <p className="text-xs text-gray-400" data-id="element-201">CBD</p>
                    <p className="text-white font-bold" data-id="element-202">
                      {product.potencyLevels.cbd}
                    </p>
                  </div>
                  <div className="bg-black/50 p-3 rounded-lg text-center" data-id="element-203">
                    <p className="text-xs text-gray-400" data-id="element-204">Terpenes</p>
                    <p className="text-white font-bold" data-id="element-205">
                      {product.potencyLevels.terpenes}
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-206">
                <h4 className="text-gray-400 text-sm mb-2" data-id="element-207">Effects</h4>
                <div className="flex flex-wrap gap-2" data-id="element-208">
                  {product.effects.map((effect, index) => <span key={index} className="bg-red-600/20 text-red-500 px-3 py-1 rounded-full text-sm" data-id="element-209">
                      {effect}
                    </span>)}
                </div>
              </div>
              <p className="text-gray-300" data-id="element-210">{product.description}</p>
            </div>
          </div>
        </div>
        <div className="mt-6" data-id="element-211">
          <button onClick={handleAddToCart} className="w-full font-display italic bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-full transition duration-300 flex items-center justify-center" data-id="element-212">
            <ShoppingCartIcon size={18} className="mr-2" data-id="element-213" />
            Add to Cart
          </button>
        </div>
      </div>
    </div>;
};
interface ProductsProps {
  showAllDetails?: boolean;
}
export const Products: React.FC<ProductsProps> = ({
  showAllDetails = false
}) => {
  const [selectedProduct, setSelectedProduct] = useState<ProductDetails | null>(null);
  return <section id="products" className="py-20 bg-gradient-dark" data-id="element-214">
      {!showAllDetails && <div className="text-center mb-16" data-id="element-215">
          <h2 className="font-display italic text-3xl sm:text-4xl font-bold mb-4" data-id="element-216">
            Premium <span className="text-red-500" data-id="element-217">Products</span>
          </h2>
          <p className="font-body italic text-gray-400 max-w-2xl mx-auto" data-id="element-218">
            Our carefully curated selection of premium cannabis products,
            showcasing the finest strains Chicago has to offer.
          </p>
        </div>}
      <div className="container mx-auto px-4" data-id="element-219">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-220">
          {products.map(product => <div key={product.id} className="bg-black/50 backdrop-blur-sm border border-red-600/20 rounded-xl overflow-hidden hover:border-red-500/50 transition duration-300 group" data-id="element-221">
              <div className="h-64 overflow-hidden" data-id="element-222">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition duration-500 group-hover:scale-110" data-id="element-223" />
              </div>
              <div className="p-6" data-id="element-224">
                <div className="flex justify-between items-start mb-2" data-id="element-225">
                  <h3 className="font-display italic text-xl font-bold text-white" data-id="element-226">
                    {product.name}
                  </h3>
                  <span className="font-body text-xs px-2 py-1 rounded bg-red-600/90 text-white" data-id="element-227">
                    {product.thc}
                  </span>
                </div>
                <p className="font-body italic text-gray-400 mb-4" data-id="element-228">
                  {product.category}
                </p>
                <button onClick={() => setSelectedProduct(product)} className="font-display italic w-full bg-transparent hover:bg-red-600 text-white border border-red-600 hover:border-transparent rounded-full py-2 transition duration-300" data-id="element-229">
                  View Details
                </button>
              </div>
            </div>)}
        </div>
        {selectedProduct && <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} data-id="element-230" />}
      </div>
    </section>;
};